const getLastDayOfCurrentMonth = () => {
  const date = new Date()
  return new Date(date.getFullYear(), date.getMonth() + 1, 0)
}

export default getLastDayOfCurrentMonth
